<template>
    <appbar-view />
  <v-app>
    <v-main>
    
      <v-navigation-drawer v-model="drawer" temporary>
        <v-list>
          <!-- Inicio -->
          <v-list-item link to="/home" @click="closeDrawer">
            <template #prepend>
              <v-avatar size="28" class="mr-2">
                <v-img
                  src="https://tse2.mm.bing.net/th/id/OIP.MS5OosTTRq5tUOV31w9EEAHaHa?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3" />
              </v-avatar>
            </template>
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item>

          <!-- Pedidos -->
          <v-list-item link to="/pedidos" @click="closeDrawer">
            <template #prepend>
              <v-avatar size="28" class="mr-2">
                <v-img
                  src="https://static.vecteezy.com/system/resources/previews/012/714/703/original/carton-box-icon-and-illustration-vector.jpg" />
              </v-avatar>
            </template>
            <v-list-item-title>Pedidos</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="user.email === 'jorgepenagos50@gmail.com'" link to="/dashboard-admin" @click="closeDrawer">
            <template #prepend>
              <v-avatar size="28" class="mr-2">
                <v-img src="" />
              </v-avatar>
            </template>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>

          <!-- Usuario -->
          <v-list-item link to="/user-info" @click="closeDrawer">
            <template #prepend>
              <v-avatar size="28" class="mr-2">
                <v-img src="https://img.icons8.com/emoji/48/bust-in-silhouette.png" />
              </v-avatar>
            </template>
            <v-list-item-title>Usuario</v-list-item-title>
          </v-list-item>

          <!-- Separador -->
          <v-divider class="my-2" />

          <!-- Cerrar sesión -->

          <!-- Separador de cierre de sesión -->
          <v-divider class="my-2" />
          <v-list-item link to="/user-info" @click="cerrarSesion">
            <template #prepend>
              <v-avatar size="28" class="mr-2">
                <v-img src="https://cdn-icons-png.flaticon.com/512/6811/6811880.png" />
              </v-avatar>
            </template>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item>

          <v-divider class="my-2" />
          <v-list-item link to="/aviso-privacidad">
            <template #prepend>
              <v-avatar size="28" class="mr-2">
                <v-img src="https://img.freepik.com/vector-premium/icono-aviso-privacidad_1076610-16600.jpg" />
              </v-avatar>
            </template>
            <v-list-item-title>Aviso de privacidad</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>


      <v-btn
  icon
  @click="drawer = !drawer"
  style="
    position: fixed;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 2200;
    border-radius: 0 8px 8px 0;
    background-color: orange;
    color: white;
    padding: 8px;
  "
>
  <v-icon>
    {{ drawer ? 'mdi-chevron-left' : 'mdi-chevron-right' }}
  </v-icon>
</v-btn>



      <v-card max-width="100%" color="white" class="py-2 px-2">
        <!-- 🔥 Promociones -->
        <div class="w-full text-center mb-4">
          <h2 class="text-xl font-bold text-orange-500 drop-shadow-md">
            🔥 Promociones Exclusivas 🔥
          </h2>
          <p class="text-gray-600 mt-2 text-xs">
            Descuentos limitados para que ahorres al máximo 🛒
          </p>

          <v-carousel v-if="chunkedPromotions.length" cycle height="300" interval="3000" :hide-delimiters="true"
            color="blue" touch="false">
            <v-carousel-item v-for="chunk in chunkedPromotions" :key="chunk[0].id">
              <v-card variant="solo" v-for="promo in chunk" :key="promo.id"
                class="pa-2 d-flex flex-column align-center text-center">
                <v-img :src="promo.foto_banner" contain height="150" width="150" class="mb-1" />
                <br>
                <v-card-title class="text-blue pa-0 mb-0" style="font-size: 15px; line-height: 12px;">
                  {{ promo.nombre }}
                </v-card-title>
                <v-card-actions class="pa-0">
                  <v-btn color="green" rounded="full" x-small variant="elevated" class="d-flex align-center gap-1"
                    @click="addToCart2(promo)">
                    <v-icon size="14">mdi-plus</v-icon> Agregar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-carousel-item>
          </v-carousel>


          <v-col cols="12">
            <v-container fluid class="py-1 px-1 d-flex flex-row justify-center align-center text-center"
              style="backdrop-filter: blur(5px); border-radius: 10px; background-size: cover; color: white;">
              <v-btn icon x-small variant="text" :href="'https://wa.link/plk405'" target="_blank" color="green">
                <v-icon size="40" color="green">mdi-whatsapp</v-icon>
              </v-btn>

              <v-btn icon x-small variant="text" :href="'https://www.facebook.com/GrupoMVDistribuidores'"
                target="_blank" color="white">
                <v-icon size="40" color="blue">mdi-facebook</v-icon>
              </v-btn>

              <v-btn icon x-small variant="text" :href="'https://www.instagram.com/grupomv.distribuciones/'"
                target="_blank" color="white">
                <v-icon size="40" color="pink">mdi-instagram</v-icon>
              </v-btn>
            </v-container>
          </v-col>




          <v-sheet height="150" class="d-flex justify-center align-center mt-2">

            <v-carousel cycle :hide-delimiters="true" :show-arrows="false" height="120" interval="3000" touch="false">
              <v-carousel-item v-for="(item, index) in transitions" :key="`logo-${index}`">
                <v-img :src="item.image" contain height="200" width="80" class="mx-auto" style="object-fit: contain;" />
              </v-carousel-item>
            </v-carousel>

            <v-carousel cycle :hide-delimiters="true" :show-arrows="false" height="140" interval="3000"
              style="background: transparent;" touch="false">
              <v-carousel-item v-for="(image, index) in bannerImages" :key="index">
                <v-img :src="image" max-height="140" contain />
              </v-carousel-item>
            </v-carousel>
          </v-sheet>

        </div>

        <!-- 🔹 Logos marcas más grandes -->
        <CartDialog v-model="cartDialog" />
      </v-card>
      <PromoView></PromoView>




      <v-snackbar v-model="snackbar" :timeout="500" top right color="blue-darken-4" text>
        {{ snackbarText }}
      </v-snackbar>


      <!-- Botón flotante tipo Didi/Rappi -->
      <v-btn icon class="floating-cart-btn" color="blue-darken-4" @click="openCart" elevation="10">
        <v-icon color="white" size="28">mdi-cart-outline</v-icon>
        <span v-if="totalCajas > 0" class="cart-badge">{{ totalCajas }}</span>
      </v-btn>



      <bottom-navigation class="fixed-bottom-nav" />


    </v-main>

  </v-app>

</template>

<script>
import axios from "axios";
import AppbarView from "./appbar/appbarView.vue";
import CartDialog from "./Administrador/CarritoViewStore.vue";
import { inject, computed, ref, onMounted } from "vue";
import { useUserStore } from "@/stores/userStore"; // ✅ importa el store
import { Storage } from "@capacitor/storage"; // <- Importamos Capacitor Storage
import PromoView from "./PromoView.vue";
import BottomNavigation from "./submenu/BottomNavigation.vue";

export default {
  name: "HomeView",
  components: { BottomNavigation, AppbarView, CartDialog, PromoView },

  setup() {
    const cartStore = inject("cartStore");
    const userStore = useUserStore(); // ✅ instancia del store Pinia

    // -----------------------
    // REACTIVOS
    // -----------------------
    const logoSlider = ref(null);
    const currentSlide = ref(0);

    const bannerImages = ref([
      "https://www.penafiel.com/wp-content/uploads/2023/01/penafiel-product-agua-mineral.jpg",
      "https://oxxo-com.s3.amazonaws.com/media-library/26b303e380302ce036934e0c2ad75649.png",
      "https://m.media-amazon.com/images/I/81a5BpHLgoL.jpg",
      "https://cocktail.pe/wp-content/uploads/2022/08/Sunset-Peach-1-683x1024.jpg",
      "https://m.media-amazon.com/images/I/61HjQDBJqRL.jpg",
      "https://scontent.ftgz2-1.fna.fbcdn.net/v/t1.6435-9/149293396_2882731695335236_6227050089449955787_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=127cfc&_nc_ohc=ek83rQWO3ikQ7kNvwENs-CK&_nc_oc=Adm4o5UozQiu7aMh7ZiRGoBTIP7DvLX6yqo97v_jN7bjrTFdi8WjImZc3EX1QIiyUzHc9YqKmZlNS5LXcSIIkrd0&_nc_zt=23&_nc_ht=scontent.ftgz2-1.fna&_nc_gid=xOR_AqY53BO1fY44EFbZSA&oh=00_AfdKuaUd9mELxjZjWzGLA7ezTUyfdDnRh2eKrvgBbMc3QQ&oe=69139200",
      "https://scontent.ftgz2-1.fna.fbcdn.net/v/t39.30808-6/558448794_1104112471843637_1166716243724249719_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=127cfc&_nc_ohc=03k112ys_94Q7kNvwHkk-L9&_nc_oc=Adm6ea2DqBTZqg3wXUrLvtGovt3TUl4GCkvie3e3pbULMPO6JqPpnUJbOFrk9GdeOjSuOIStui55kERFXa6lHrEh&_nc_zt=23&_nc_ht=scontent.ftgz2-1.fna&_nc_gid=IiIDArWhGmON438bGv37Mg&oh=00_Afft9AWEWmyNTKM2YZPYsAE43Pt1TRggO50a68wPr0okgg&oe=68F205CB"

    ]);

    const transitions = ref([

      {
        expanded: false,
        image:
          "https://www.penafiel.com/wp-content/themes/penafiel/images/penafiel-logo.png",
        color: "bg-white",
      },
      {
        expanded: false,
        image:
          "https://pngimg.com/uploads/red_bull/red_bull_PNG24.png",
        color: "bg-white",
      },
      {
        expanded: false,
        image: "https://cdn.uc.assets.prezly.com/8b851933-e208-4958-8d79-8bc2feebea74/-/resize/992/-/format/png/",
        color: "bg-white",
      },
      {
        expanded: false,
        image:
          "https://www.boones.mx/assets/images/logo-boones.png",
        color: "bg-white",
      },
      {
        expanded: false,
        image:
          "https://logos-world.net/wp-content/uploads/2021/09/Jack-Daniels-Logo.png",
        color: "bg-white",
      },
      {
        expanded: false,
        image:
          "https://vectorseek.com/wp-content/uploads/2023/08/volt-Logo-Vector.svg-.png",
        color: "bg-white",
      },
      {
        expanded: false,
        image:
          "https://grupomv.mx/images/logos/4.png",
        color: "bg-white",
      },
    ]);

    const user = ref({})

    const promotions = ref([]);
    const promoGifts = ref([]);
    const searchQuery = ref("");
    const snackbar = ref(false);
    const snackbarText = ref("");
    const cartDialog = ref(false);
    const drawer = ref(false);
    const cart = ref(JSON.parse(localStorage.getItem("cart")) || []);

    const totalCajas = computed(() => {
      return cartStore?.state.cart.reduce((t, item) => t + item.quantity, 0) || 0;
    });

    const filteredPromotions = computed(() => {
      if (!searchQuery.value) return promotions.value;
      return promotions.value.filter((p) =>
        p.nombre.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    async function fetchPromotions() {
      const cacheKey = "promotionsCacheMain";
      const cacheTimeKey = cacheKey + "_time";
      const cache = localStorage.getItem(cacheKey);
      const cacheTime = Number(localStorage.getItem(cacheTimeKey));
      const now = Date.now();
      const oneHour = 2 * 60 * 1000; // 1 hora en ms

      // Si hay cache válida y no ha pasado 1 hora
      if (cache && cacheTime && now - cacheTime < oneHour) {
        promotions.value = JSON.parse(cache);
        return;
      }

      try {
        const { data } = await axios.get(
          "https://mvexpress.mx/api/promo-app"
        );
        promotions.value = data;

        // Guardar cache con timestamp
        localStorage.setItem(cacheKey, JSON.stringify(data));
        localStorage.setItem(cacheTimeKey, now.toString());
      } catch (e) {
        console.error("Error al obtener promociones:", e);
      }
    }

    async function fetchPromoGifts() {
      const cacheKey = "promotionsCacheMainGift";
      const cacheTimeKey = cacheKey + "_time";
      const cache = localStorage.getItem(cacheKey);
      const cacheTime = Number(localStorage.getItem(cacheTimeKey));
      const now = Date.now();
      const oneHour = 0 * 60 * 1000; // 1 hora en ms

      if (cache && cacheTime && now - cacheTime < oneHour) {
        promoGifts.value = JSON.parse(cache);
        return;
      }

      try {
        const token = localStorage.getItem("token");
        const { data } = await axios.get(
          "https://mvexpress.mx/api/promo-gift",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        promoGifts.value = data;

        localStorage.setItem(cacheKey, JSON.stringify(data));
        localStorage.setItem(cacheTimeKey, now.toString());
      } catch (e) {
        console.error("Error al cargar promociones de regalo:", e);
      }
    }


    async function addToCart2(item) {
      await cartStore?.addToCart2(item);
      snackbarText.value = "Promoción agregada al carrito";
      snackbar.value = true;
    }
    function scrollLeftLogos() {
      if (logoSlider.value) {
        logoSlider.value.scrollBy({ left: -logoSlider.value.offsetWidth, behavior: 'auto' });
      }
    }

    function scrollRightLogos() {
      if (logoSlider.value) {
        logoSlider.value.scrollBy({ left: logoSlider.value.offsetWidth, behavior: 'auto' });
      }
    }
    async function addGiftToCart(item) {
      await cartStore?.addGiftToCart(item);
    }


    function cerrarSesion() {
      // Limpiamos localStorage
      ["token", "user", "direccionSeleccionada", "carrito"].forEach((k) =>
        localStorage.removeItem(k)
      );

      // Limpiamos Capacitor Storage
      Storage.remove({ key: "auth_token" });
      Storage.remove({ key: "email" });

      // Limpiamos Pinia si tienes un store de usuario
      userStore.$reset?.();

      // Redirigimos al login
      window.location.replace("/"); // o usar router.push("/") si estás en SPA
    }

    function openCart() {
      cartDialog.value = true;
    }

    function formatDate(dateStr) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateStr).toLocaleDateString("es-MX", options);
    }

    // ✅ Nuevo método para validar política usando Pinia
    async function verificarPolitica() {
      // Actualiza datos de usuario desde el backend
      await userStore.obtenerNuevaData();

      // Si no hay usuario o no ha aceptado la política, redirigir
      if (!userStore.user?.politica_privacidad_aceptada) {
        window.location.replace("/aviso-privacidad");
      }
    }

    const chunkedPromotions = computed(() => {
      const size = 1; // número de tarjetas visibles por slide
      const chunks = [];
      for (let i = 0; i < filteredPromotions.value.length; i += size) {
        chunks.push(filteredPromotions.value.slice(i, i + size));
      }
      return chunks;
    });

    // -----------------------
    // MOUNT
    // -----------------------
    onMounted(async () => {
      const storedUser = localStorage.getItem('user')
      if (storedUser) {
        user.value = JSON.parse(storedUser)
      }

      fetchPromotions();
      fetchPromoGifts();

      const token = localStorage.getItem("token");
      if (!token) {
        window.location.replace("/");
        return;
      }

      // ✅ Usar el método centralizado
     // await verificarPolitica();
    });

    return {
      bannerImages,
      transitions,
      promotions,
      promoGifts,
      searchQuery,
      snackbar,
      snackbarText,
      cartDialog,
      cart,
      filteredPromotions,
      totalCajas,
      addToCart2,
      addGiftToCart,
      openCart,
      drawer,
      cerrarSesion,
      formatDate,
      currentSlide,
      verificarPolitica,
      scrollLeftLogos,
      scrollRightLogos,
      logoSlider,
      chunkedPromotions,
      user,

      // opcional por si quieres llamarlo desde el template
    };
  },
};
</script>
<style>
.snackbar-top {
  top: 30px !important;
  /* Ajusta la distancia del top */
  bottom: auto !important;
  z-index: 2000 !important;
}

.floating-cart-btn {
  position: fixed;
  bottom: 150px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Burbuja de contador */
.cart-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: red;
  color: white;
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 10px;
}

.main-content {
  height: 100vh;
  /* Ocupa toda la pantalla */
  padding-bottom: 80px;
  /* Deja espacio para la bottom-navigation */
}

.marcas {
  display: flex;
  /* asegura que flex funcione */
  justify-content: center;
  /* centra elementos */
  overflow-x: auto;
  /* scroll horizontal */
  padding: 0 16px;
  /* margen interno */
  gap: 20px;
  /* espacio entre items */
  scroll-behavior: smooth;
  /* scroll suave */
}

.marcas::-webkit-scrollbar {
  display: none;
}

/* Cada item no se reduce */
.marcas .v-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* centra contenido dentro de la columna */
  padding: 0;
}

/* Para Samsung donde env(safe-area) no se reporta correctamente */
@supports (bottom: env(safe-area-inset-bottom)) {
  .fixed-cart-btn {
    bottom: calc(max(env(safe-area-inset-bottom), 20px) + 70px);
  }
}
</style>
